import React, { Fragment } from 'react'

import { useUnit } from 'effector-react'

import { useEffect, useMediaQueries } from 'hooks'

import AllCenter from 'components/_old/AllCenter/AllCenter.jsx'
import Button from 'components/_old/Button/Button.jsx'
import { Typo } from 'components/_old/Typo/Typo'
import Width from 'components/_old/Width/Width'

import { Paper } from 'components/atoms/Paper'
import { Typography } from 'components/atoms/Typography'

import { CheckboxWithLabel } from 'components/molecules/WithLabel/WithLabel.jsx'

import { RecoveryCode } from 'app/pages/Dashboard/UserProfile/LoginSettings/components/RecoveryCodeModal/RecoveryCode'

import { $recoveryCode, generateRecoveryCodeFx, saveRecoveryCode } from '../model'
import { TwoFactorSetupLayout } from '../TwoFactorSetupLayout'

import { $isConfirmRecoveryCodeChecked, setIsConfirmRecoveryCodeChecked } from './model'
import recoveryCodeImage from './recoveryCode.png'

const RecoveryCodeStep = (): React.ReactElement => {
  const { desktop } = useMediaQueries()

  const [
    recoveryCode,
    isConfirmRecoveryCodeChecked,
    handleSetIsConfirmRecoveryCodeChecked,
    handleGenerateRecoveryCode,
    handleSaveRecoveryCode,
  ] = useUnit([
    $recoveryCode,
    $isConfirmRecoveryCodeChecked,
    setIsConfirmRecoveryCodeChecked,
    generateRecoveryCodeFx,
    saveRecoveryCode,
  ])

  useEffect(() => {
    handleGenerateRecoveryCode()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const content = (
    <Fragment>
      <Typography size={desktop ? 32 : 24} weight="semibold" lineHeight="small" align="center">
        <Typo>Save your recovery phrase</Typo>
      </Typography>
      <Paper top={8}>
        <Typography size={14} align="center">
          <Typo>This phrase helps restore access if you lose your phone. Keep it safe for easy recovery.</Typo>
        </Typography>
      </Paper>
      <Paper top={40}>
        <AllCenter>
          <img src={recoveryCodeImage} width={240} height={240} />
        </AllCenter>
      </Paper>
      <Paper top={16}>
        <Width size={36} center>
          <RecoveryCode recoveryCode={recoveryCode.raw} onRegenerate={handleGenerateRecoveryCode} />
        </Width>
      </Paper>
    </Fragment>
  )

  const button = (
    <Fragment>
      <CheckboxWithLabel
        label={
          <Typography size={14}>
            <Typo>I've written down the recovery phrase and understand the risk associated with losing the code</Typo>
          </Typography>
        }
        checked={isConfirmRecoveryCodeChecked}
        onChange={handleSetIsConfirmRecoveryCodeChecked}
      />
      <Paper top={16}>
        <Button mods={{ size: 'big block' }} onClick={handleSaveRecoveryCode} disabled={!isConfirmRecoveryCodeChecked}>
          Finish
        </Button>
      </Paper>
    </Fragment>
  )

  return (
    <TwoFactorSetupLayout button={button}>
      <Paper top={40}>
        <Width size={45} center>
          {content}
        </Width>
        {desktop && (
          <Paper top={64}>
            <Width size={26} center>
              {button}
            </Width>
          </Paper>
        )}
      </Paper>
    </TwoFactorSetupLayout>
  )
}

export { RecoveryCodeStep }
